<template>
  <a class="deviceElement d-flex justify-content-center align-items-center">
    <div class="deviceBox h-100 w-100 d-flex justify-content-center align-items-center" v-if="!showNewItemMenu" @click="openNewItemMenu">
      <div class="addIcon">
        <img src="@/assets/images/addIcon.png"/>
      </div>
    </div>
    <div class="deviceBox" v-if="showNewItemMenu">
      <div>
        <label>{{ $t('participantGui.selectDeviceType') }}</label>
      </div>
      <div @click.stop class="d-flex flex-column">
        <button class="button button-ghost-primary" @click="addDevice(1)">
          <i class="vertical-align-middle fa-kit fa-interior-light me-1"></i>
          {{ $t('participantGui.controlGear') }}

        </button>
        <button class="button button-ghost-primary" @click="addDevice(4)">
          <i class="vertical-align-middle fa-kit fa-relais fa-2x"></i>
          {{ $t('participantGui.relay') }}
        </button>
        <button class="button button-ghost-primary" v-if="isInputDeviceAllowed" @click="addDevice(3)">
          <i class="vertical-align-middle fa-kit fa-beg-pbm fa-2x"></i>
          {{ $t('participantGui.inputDevice') }}
        </button>
        <button class="button button-ghost-primary" v-if="isSensorAllowed" @click="addDevice(2)">
          <i class="vertical-align-middle fa-kit fa-pd4 fa-2x"></i>
         {{ $t('participantGui.sensor') }}
        </button>

      </div>
    </div>
  </a>

</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: "BusDeviceCard",
  data() {
    return {
      showNewItemMenu: false
    }
  },
  methods: {
    openNewItemMenu() {
      this.showNewItemMenu = true;
    },
    closeNewItemMenu() {
      this.showNewItemMenu = false;
    },
    addDevice(deviceType) {
      let current = 2;
      let name = this.$t('participantGui.controlGear')
      if (deviceType == 2) {
        current = 7,
            name = this.$t('participantGui.sensor')
      }
      if (deviceType == 3) {
        name = this.$t('participantGui.inputDevice')
        current = 7
      }
      if (deviceType == 4) {
        name = this.$t('participantGui.relay')
        current = 10
      }
      let device = {
        name: name,
        typeCategory: deviceType,
        amount: 1,
        current: current
      }
      this.$store.dispatch('busDevice/addDevice', device)
      this.$emit('onChange')
      this.closeNewItemMenu();
    }
  },
  computed: {
    ...mapGetters({
      selectedController: 'product/getSelectedApplicationController',
      imagePath: 'app/getImagePath'
    }),
    isSensorAllowed() {
      if (this.selectedController === undefined) {
        return false
      }
      if (this.selectedController.slaveSensorTechnologie !== null) {
        return true;
      } else {
        return false
      }
    },
    isInputDeviceAllowed() {
      if (this.selectedController === undefined) {
        return false
      }
      if (this.selectedController.slaveInputTechnologie !== null) {
        return true;
      } else {
        return false
      }
    }
  },
  props: {
    type: String
  }
}
</script>

<style lang="scss" scoped>

</style>